export enum LAYOUT_OPTIONS {
    HYDROGEN = 'hydrogen',
    HELIUM = 'helium',
    LITHIUM = 'lithium',
    BERYLLIUM = 'beryllium',
  }
  
  export enum PaymentGateway {
    STRIPE = 'STRIPE',
    COD = 'CASH_ON_DELIVERY',
    CASH = 'CASH',
    FULL_WALLET_PAYMENT = 'FULL_WALLET_PAYMENT',
    PAYPAL = 'PAYPAL',
    MOLLIE = 'MOLLIE',
    RAZORPAY = 'RAZORPAY',
    SSLCOMMERZ = 'SSLCOMMERZ',
    PAYSTACK = 'PAYSTACK',
    PAYMONGO = 'PAYMONGO',
    XENDIT = 'XENDIT',
    IYZICO = 'IYZICO',
    BKASH = 'BKASH',
  }
  
  export enum CouponType {
    FIXED = 'fixed',
    PERCENTAGE = 'percentage',
    FREE_SHIPPING = 'free_shipping',
  }
  